import * as React from "react";
import Drawer from "@mui/material/Drawer";
import { ApplicationSummary, ClientConfig } from "gen/clients";
import { DrawerHeader } from "components/DrawerHeader/DrawerHeader";
import { DrawerBody } from "components/DrawerBody/DrawerBody";
import { ApplicationId } from "types/ApplicationId";
import { MachineTranslationSettings } from "./MachineTranslationSettings/MachineTranslationSettings";
import { ReportsSettings } from "./ReportsSettings/ReportsSettings";
import { CreateProjectSettings } from "./CreateProjectSettings/CreateProjectSettings";
import { PowerBiReportsSettings } from "./PowerBiReportsSettings/PowerBiReportsSettings";

interface Props {
  application: ApplicationSummary;
  clientConfig: ClientConfig;
  onClose: () => void;
  onSaveSuccess: () => void;
}

const ApplicationSettingsPanel: React.FC<Props> = ({ application, clientConfig, onClose, onSaveSuccess }) => {
  return (
    <Drawer open={true} onClose={onClose} anchor="right" PaperProps={{ sx: { width: "80vw" } }}>
      <DrawerHeader title={`${application.name || application.id} Settings`} onClose={onClose} />
      <DrawerBody>
        {application.id === ApplicationId.machineTranslation && (
          <MachineTranslationSettings clientConfig={clientConfig} onSaveSuccess={onSaveSuccess} />
        )}
        {application.id === ApplicationId.reports && (
          <ReportsSettings clientId={clientConfig.id} onSaveSuccess={onSaveSuccess} />
        )}
        {application.id === ApplicationId.pbiReports && (
          <PowerBiReportsSettings clientId={clientConfig.id} onSaveSuccess={onSaveSuccess} />
        )}
        {application.id === ApplicationId.createProject && (
          <CreateProjectSettings clientConfig={clientConfig} onSaveSuccess={onSaveSuccess} onClose={onClose} />
        )}
      </DrawerBody>
    </Drawer>
  );
};

export { ApplicationSettingsPanel };
